import { ref } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import TwilioService from '../../services/twilio.service';
import { useRootStore } from '../../../store/root.store';

export const useTwilio = () => {
  const callSid = ref('');
  const loading = ref(false);
  const error = ref(null);
  const rootStore = useRootStore();

  const callPhone = async (phoneNumber: string) => {
    error.value = null;
    loading.value = true;
    try {
      const reponse = await TwilioService.callPhone(
        rootStore.documentId,
        rootStore.recipientId,
        rootStore.authId,
        phoneNumber
      );
      switch (reponse.status) {
        case '1':
          callSid.value = reponse.callSid;
          break;
        case '0':
          callSid.value = '';
          error.value = t('invalid-phone-entered-please-try-again');
          break;
        default:
          callSid.value = '';
          error.value = t('could-not-call-the-sender-please-contact-the-sender-manually');
          break;
      }
    } catch (e) {
      callSid.value = '';
      error.value = t('could-not-call-the-sender-please-contact-the-sender-manually');
    } finally {
      loading.value = false;
    }
  };

  const cancelCall = async () => {
    try {
      await TwilioService.cancelCall(
        rootStore.documentId,
        rootStore.recipientId,
        rootStore.authId,
        callSid.value
      );
    } catch (e) {
      console.error(e);
    }
    callSid.value = '';
    loading.value = false;
  };

  return {
    callSid,
    loading,
    error,
    callPhone,
    cancelCall,
  };
};
